import { render, staticRenderFns } from "./ScreenCard.vue?vue&type=template&id=08972167&"
import script from "./ScreenCard.vue?vue&type=script&lang=js&"
export * from "./ScreenCard.vue?vue&type=script&lang=js&"
import style0 from "./ScreenCard.vue?vue&type=style&index=0&id=08972167&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports